import React from "react";
import analytics from "web/script/analytics/analytics";
import ProductGalleryCarousel from "web/react/components/product-gallery/product-gallery-carousel/product-gallery-carousel";
import ProductGalleryModal from "web/react/components/product-gallery/product-gallery-modal/product-gallery-modal";

interface FullscreenGalleryProps {
    analyticsAction: string;
    onClose: () => void;
    images: ProductImage[];
    settings: object;
    isOpen?: boolean;
    relatedProducts?: ProductCard[];
    currentLinkId?: string;
}

function FullscreenGallery({
    analyticsAction,
    isOpen = false,
    onClose,
    images,
    settings,
    relatedProducts,
    currentLinkId,
}: FullscreenGalleryProps): React.ReactElement {
    let fullscreenProps = {
        analyticsAction: analyticsAction,
        images: images,
        isFullscreen: true,
        relatedProducts: relatedProducts,
        settings: settings,
        currentLinkId: currentLinkId,
        hasRelatedProductsSidebar: false,
    };

    function onOpen(): void {
        analytics.event("engagement", analyticsAction, "open_fullscreen");
    }

    return (
        <ProductGalleryModal isOpen={isOpen} onClose={onClose} onOpen={onOpen}>
            <ProductGalleryCarousel {...fullscreenProps} />
        </ProductGalleryModal>
    );
}

export default FullscreenGallery;
